import moment from 'moment';

export default class Rules {
  readonly name = [
    (value: string) => !!value || 'Campo obrigatório.',
    (value: string) => (!!value && value.length > 2) || 'Campo deve ter mais que 2 caracteres.',
    (value: string) => (!!value && value.length < 100) || 'Campo deve ter no máximo 100 caracteres.',
  ]

  readonly empty = [
    (value: string) => (!!value) || 'Campo obrigatório.',
  ]

  readonly emptyArray = [
    (value: string) => (!!value && value.length > 0) || 'Campo obrigatório.',
  ]

  readonly totalTime = [
    (value: string) => (!!value && parseFloat(value) >= 0 && parseFloat(value) < 24.1) || 'Valor inválido.',
  ]

  readonly grade = [
    (value: string) => (!!value && parseFloat(value) >= 0 && parseFloat(value) < 10.1) || 'Valor inválido.',
  ]

  readonly satisfaction = [
    (value: string) => (!!value && parseFloat(value) >= 0 && parseFloat(value) < 100.1) || 'Valor inválido.',
  ]

  readonly atLeastOneFieldFilled = [
    (value: any) => (!!value && !Object.values(value).every(el => el === '')) || 'Campo inválido.',
  ]

  readonly emailFormat = [
    (value: any) => (!value || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) || 'Formato de e-mail inválido',
  ]

  readonly notFutureDate = [
    (value?: string | null) => {
      if (!value) return true;
      const date = moment(value, 'DD/MM/YYYY');
      if (!date.isValid()) return true;
      return date.isSameOrBefore(moment(), 'day') || 'A data deve ser anterior ou igual a hoje.';
    },
  ]
}
